"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.domainRegex = exports.emailRegex = exports.GUIDRegex = exports.trueRegex = exports.phoneRegex = exports.colorHexRegex = void 0;
/** simplified Regex for colorHex */
exports.colorHexRegex = /^#(?:[0-9A-F]{3,4}|[0-9A-F]{6}|[0-9A-F]{8})$/i;
/** simplified Regex for Phone Number */
exports.phoneRegex = /^[\d\s\+\-\(\)\.]+$/;
/** simplified Regex for truthy value */
exports.trueRegex = /^(?:true|false|0|1)$/;
/** Regex for GUID */
exports.GUIDRegex = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|[0]{8}-[0]{4}-[0]{4}-[0]{4}-[0]{12})$/i;
/**
 * domain : domain regex
 * email: email regex
 */
exports.emailRegex = (_a = (function () {
    var anyLetter = '\u00A1-\uD7FF\uE000-\uFFFF-a-zA-Z';
    var anyDigit = '0-9';
    var anyLetterOrDigit = "".concat(anyLetter).concat(anyDigit);
    var anyAllowedSymbol = '!#$%&\'*+/=?^_`{|}~-';
    var allowedWithoutQuotes = "[".concat(anyLetterOrDigit).concat(anyAllowedSymbol, "]+(?:\\.[").concat(anyLetterOrDigit).concat(anyAllowedSymbol, "]+)*");
    var allowedBetweenQuotes = '"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*"';
    var localPart = "(?:".concat(allowedWithoutQuotes, "|").concat(allowedBetweenQuotes, ")");
    var domainPart = "(?:[".concat(anyLetterOrDigit, "](?:[").concat(anyLetterOrDigit, "-]*[").concat(anyLetterOrDigit, "])?\\.)+(?:(?:[").concat(anyDigit, "]+[").concat(anyLetter, "][").concat(anyLetterOrDigit, "]*)|(?:[").concat(anyLetter, "][").concat(anyLetterOrDigit, "]{1,}))");
    var email = new RegExp('^' + localPart + '@' + domainPart + '$');
    var domain = new RegExp(domainPart);
    return { emailRegex: email, domainRegex: domain };
})(), _a.emailRegex), exports.domainRegex = _a.domainRegex;
